/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../util/EdgeIterator'
], (EdgeIterator) => {

	'use strict';

	return class GridEdgeIterator extends EdgeIterator {

		constructor() {
			super(...arguments);
			this.EdgeIterator = GridEdgeIterator;
		}

		createLeafNodeInfo(descendant_or_self, value, edge, maxLevel) {
			const nodeInfo = {
				descendant_or_self,
				index: this.currentKeyIndex,
				value,
				type: edge.type,
				isSummary: edge.isSummary,
				isOverallSummary: edge.isOverallSummary,
				isLeafNode: true,
				isMeasure: edge.isMeasure,
				summaryOf: edge.summaryOf,
				formatSpec: edge.formatSpec
			};

			if (!edge.isSummary) {
				nodeInfo.cellIdx = edge.cellIdx;
			}

			this.rollupSummariesOfDescendents(nodeInfo, value, maxLevel);

			return nodeInfo;
		}

		createNodeInfo(descendant_or_self, value, edge, childNode, maxLevel) {
			const nodeInfo = {
				descendant_or_self,
				index: this.numberOfLeafNodes - 1,
				value,
				type: edge.type,
				isSummary: edge.isSummary || childNode.isSummary,
				isOverallSummary: edge.isOverallSummary || childNode.isOverallSummary,
				noOfChildren: this.subIterator.keys.length,
				hasLeafNode: (childNode.isLeafNode || childNode.hasLeafNode),
				ancestor_or_self: this.ancestor_or_self,
				isMeasure: edge.isMeasure,
				summaryOf: edge.summaryOf || childNode.summaryOf,
				subCategory: childNode,
				formatSpec: edge.formatSpec
			};

			this.rollupSummariesOfDescendents(nodeInfo, value, maxLevel, childNode);
			nodeInfo.descendant_or_self = nodeInfo.descendant_or_self.concat(childNode.descendant_or_self);

			if (!edge.isSummary) {
				nodeInfo.cellIdx = edge.cellIdx;
			}
			return nodeInfo;
		}
	};
});